import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { LinkageSelectionTable } from "../../../LinkageTable/components";

import { FaRegEdit } from "react-icons/fa";

const CellContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const TextContainer = styled.div`
  ${(props) =>
    props.fade &&
    `
      -webkit-mask-image: linear-gradient(180deg, #000 75%, transparent);
  `};
`;

export const LinkageEditableCell = ({
  value,
  field,
  formApi,
  index,
  setLinkageEditMode,
  linkagesValues,
  setLinkagesValues,
}) => {
  const {
    linkages: { fromFieldArray, idFieldName, descriptionFieldName },
  } = field;

  const [showMore, setShowMore] = useState(false);
  const [isSelectionOpen, setIsSelectionOpen] = useState(false);

  const setLinkageIdList = (newData) => {
    value = newData;
  };
  const formValues = formApi.getState().values;
  let linkagesList = formValues[fromFieldArray] || [];

  useEffect(() => {
    if (!!linkagesValues) {
      let linkagesValues = {};
      linkagesList?.forEach((item) => {
        linkagesValues[item?.[idFieldName]] = item?.[descriptionFieldName];
      });
      setLinkagesValues(linkagesValues);
    }
  }, []);

  const DISPLAY_COUNT = 6;

  const truncatedIdArray = showMore ? value : value?.slice(0, DISPLAY_COUNT);
  return (
    <CellContainer>
      <TextContainer
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          // gap: 10,
        }}
        fade={value?.length > DISPLAY_COUNT && !showMore}
      >
        {!!truncatedIdArray?.length && !!linkagesValues ? (
          <ul
            style={{
              marginTop: "10px",
              marginBottom: showMore ? "10px" : "0px",
              paddingLeft: 18,
            }}
            className="linkages-list"
          >
            {truncatedIdArray?.map((item, index) => {
              const itemDescription = linkagesValues?.[item];
              const MAX_CHARACTER_LENGTH = 25;

              return (
                <li
                  key={`${item}-${index}`}
                  style={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {item} -{" "}
                  {itemDescription?.length <= MAX_CHARACTER_LENGTH
                    ? itemDescription
                    : `${itemDescription?.substring(
                        0,
                        MAX_CHARACTER_LENGTH
                      )}...`}
                </li>
              );
            })}
          </ul>
        ) : (
          <em>No Items Listed</em>
        )}
        <FaRegEdit
          onClick={(e) => {
            if (!isSelectionOpen) {
              setIsSelectionOpen(true);
            }
          }}
          style={{ cursor: "pointer" }}
          color={"#005EA2"}
        />
        <LinkageSelectionTable
          linkageIdList={value}
          setLinkageIdList={setLinkageIdList}
          schemaProps={field}
          formApi={formApi}
          saveRowIndex={index}
          setIsOpen={setIsSelectionOpen}
          isOpen={isSelectionOpen}
          setLinkageEditMode={setLinkageEditMode}
        />
      </TextContainer>
      {value?.length > DISPLAY_COUNT && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            style={{
              background: "transparent",
              border: "none",
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
              color: "#005EA2",
              textDecoration: "underline",
            }}
            onClick={() => setShowMore(!showMore)}
          >
            <span
              style={{
                fontSize: 16,
                marginRight: 4,
              }}
            >
              Show {showMore ? `less` : `all (${value?.length})`}
            </span>
          </button>
        </div>
      )}
    </CellContainer>
  );
};
